import { useDialogShadow } from "@evergis/ui";
import React, { FC } from "react";
import { DialogTitle, DialogTitleProps } from "../DialogTitle";
import { DefaultFullScreenDialogProps, FullScreenDialog } from "../FullScreenDialog";
import { DialogContent } from "../styled";
import DialogWizardStepActions, { DialogWizardStepActionsProps } from "./DialogWizardStepActions";

export type DialogWizardStepProps = Pick<DialogTitleProps, "extra"> &
  Pick<
    DialogWizardStepActionsProps,
    "nextStepDisabled" | "extraActions" | "onPreviousStep" | "onNextStep" | "onCancel"
  > &
  Pick<DefaultFullScreenDialogProps, "dialogContext"> & {
    displayBottomShadow?: boolean;
  };

export const DialogWizardStep: FC<DialogWizardStepProps> = ({
  extra,
  extraActions,
  nextStepDisabled,
  dialogContext,
  onNextStep,
  onPreviousStep,
  onCancel,
  displayBottomShadow = true,
  children,
}) => {
  const { shadows, setScrollContainer } = useDialogShadow();

  return (
    <FullScreenDialog dialogContext={dialogContext}>
      <DialogTitle displayShadow={shadows.upper} extra={extra} />
      <DialogContent ref={setScrollContainer} style={{ paddingTop: "0" }}>
        {children}
      </DialogContent>
      <DialogWizardStepActions
        displayShadow={displayBottomShadow && shadows.bottom}
        nextStepDisabled={nextStepDisabled}
        extraActions={extraActions}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
        onCancel={onCancel}
      />
    </FullScreenDialog>
  );
};
